import { useUserIdentityState } from '@provider/user-identity';
import { PublisherLogo } from '@ui/kit/icons';
import { footer, pageContext, pageNumber, copyright, publisherLogo } from './pm2.footer.style.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

const PM2PrintFooterSlot = context => ({
  content: /*#__PURE__*/jsx(PM2PrintFooter, {
    context: context
  }),
  designSizeInPx: {
    width: 794,
    height: 1123
  }
});
function PM2PrintFooter(props) {
  const user = useUserIdentityState(state => state.user);
  return /*#__PURE__*/jsxs("footer", {
    className: footer,
    children: [/*#__PURE__*/jsx("div", {
      className: pageContext,
      children: props.context.physical && /*#__PURE__*/jsxs("span", {
        className: pageNumber,
        children: [/*#__PURE__*/jsx("b", {
          children: props.context.physical.currentPageIndexInDocument + 1
        }), "/", props.context.physical.pagesInDocument]
      })
    }), /*#__PURE__*/jsxs("div", {
      className: copyright,
      children: ["Print og kopiering af dette materiale er tilladt, forudsat at det sker i overensstemmelse med skolens aftale med Tekst & Node.", /*#__PURE__*/jsx("br", {}), "Dette arbejdsark er udskrevet ", user && /*#__PURE__*/jsxs(Fragment, {
        children: ["af ", user.name]
      }), ", GYLDENDAL A/S,", " ", new Date().toLocaleDateString("da-DK", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      })]
    }), /*#__PURE__*/jsx("div", {
      className: pageContext,
      children: /*#__PURE__*/jsx(PublisherLogo, {
        small: true,
        className: publisherLogo
      })
    })]
  });
}

export { PM2PrintFooterSlot };
//# sourceMappingURL=pm2.footer.js.map
